import { render, staticRenderFns } from "./Act.vue?vue&type=template&id=7b3d5aa4"
import script from "./Act.vue?vue&type=script&lang=js"
export * from "./Act.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports